import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'


import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';

import api_manager from '@/api/manager.js'
import config from '@/config2.js'
// Vue.use(ElementUI)
Vue.use(ElementUI, { size: 'small', zIndex: 3000 });

Vue.config.productionTip = false

Vue.mixin({
  filters: {
      $_staticPicFilter(pic){
        return "."+pic
      },
      $_timeFilter: function(time) {
          var str = '';
          var d = new Date(time);
          str += d.getFullYear() + "年" + (d.getMonth() + 1) + "月" + d.getDate() + "日" + d.getHours() + ":" + d.getMinutes()
          return str;
      },
      $_mdhm_timeFilter: function(time) {
        var str = '';
        var d = new Date(time);
        str += (d.getMonth() + 1) + "月" + d.getDate() + "日" + d.getHours() + ":" + d.getMinutes()
        return str;
    }
  }
})

new Vue({
  router,
  store,
  data: {
    eventHub: new Vue(),
    wsServer:undefined
  },
  async mounted(){
    var user_id = sessionStorage["user_id"];
    if(user_id){
      var user=await api_manager.baseInfo(user_id);
      this.$store.commit("user",user)
      sessionStorage.setItem('user_id',user.id); // 存入一个值
      this.$root.eventHub.$emit('onUserLoadEndEvent',user)
      this.socketEvent();
    }
  },
  methods:{
    GetQueryString (name) {
      return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
    },
    connectServer: function() {
      if(!sessionStorage["user_id"])return ;
      var params = {
          type: "JOIN",
          userId: sessionStorage["user_id"]
      }
      console.log(params)
      this.wsServer.send(JSON.stringify(params))
  },
    socketEvent: function() {
      this.wsServer = new WebSocket(config.ws);
      this.wsServer.onopen = (e) => {
          this.connectServer();
      };
      this.wsServer.onclose = (e) => { //当链接关闭的时候触发
        this.$confirm('连线断开，请重新链接或刷新', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          this.socketEvent();
        }).catch(() => {
               
        });
      };
      this.wsServer.onmessage = (e) => { //后台返回消息的时候触发
        console.log(e)
          var params = JSON.parse(e.data)
          console.log(params)
          var msgJson=params.msg;
          var type = params.type;
          if (type == "JOIN") {
            var res=msgJson["res"];
            if(res=="SUCCESS"){

            }
          }
          this.$root.eventHub.$emit(type,msgJson)
          if (type == "SMS_TASK_FINISHED") {
            this.$notify({
              title: '提示',
              message: '有用户完成了任务',
              duration: 0
            });
          }
          if(type=="SMS_TASK_RECEIVED"){
            this.$notify({
              title: '提示',
              message: '有用户接单啦',
              duration: 0
            });
          }
          if(type=="SMS_TASK_CANCEL"){
            this.$notify({
              title: '提示',
              message: '有用户取消了任务',
              duration: 0
            });
          }
          
      };
      this.wsServer.onerror = (e) => { //错误情况触发

      }
    }
  },
  render: h => h(App)
}).$mount('#app')
